import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-hockey",
  "use": "icon-si-glyph-hockey-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-hockey\" id=\"icon-si-glyph-hockey\"><title>690</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><path d=\"M4.938,15.969 L1.032,15.969 C0.479,15.969 0.032,15.522 0.032,14.969 C0.032,14.416 0.479,14.053 1.032,14.053 L4.839,14.053 C4.901,13.94 4.982,13.748 5.017,13.665 L10.022,0.818 C10.244,0.313 10.829,0.082 11.339,0.301 C11.845,0.523 12.076,1.112 11.856,1.618 L6.856,14.368 C6.605,14.96 6.181,15.969 4.938,15.969 L4.938,15.969 Z\" class=\"si-glyph-fill\" /><rect x=\"9\" y=\"15\" width=\"2.938\" height=\"1\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-hockey.svg
// module id = GpN6
// module chunks = 62